import React from 'react';
import styled from 'styled-components';

const StyledPortfolioSection = styled.section`
  padding: 100px 150px;
  max-width: 1000px;
  margin: 0 auto;

  h2 {
    display: flex;
    align-items: center;
    position: relative;
    margin: 10px 0 40px;
    width: 100%;
    font-size: clamp(26px, 5vw, 32px);
    white-space: nowrap;

    &:after {
      content: '';
      display: block;
      position: relative;
      top: 0;
      width: 300px;
      height: 1px;
      margin-left: 20px;
      background-color: var(--lightest-navy);
    }
  }
`;

const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 15px;
`;

const StyledProject = styled.div`
  padding: 2rem 1.75rem;
  background-color: var(--light-navy);
  border-radius: 4px;
  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

  &:hover {
    transform: translateY(-7px);
  }

  h3 {
    margin: 0 0 10px;
    font-size: 20px;
    color: var(--lightest-slate);
  }

  p {
    color: var(--light-slate);
  }
`;

const projects = [
  {
    title: 'Project Alpha',
    description: 'A machine learning platform for a leading e-commerce company.',
  },
  {
    title: 'Project Beta',
    description: 'An AI-powered chatbot for a major financial institution.',
  },
  {
    title: 'Project Gamma',
    description: 'A computer vision system for a manufacturing client.',
  },
];

const Portfolio = () => (
  <StyledPortfolioSection id="portfolio">
    <h2>Our Work</h2>
    <StyledGrid>
      {projects.map((project, i) => (
        <StyledProject key={i}>
          <h3>{project.title}</h3>
          <p>{project.description}</p>
        </StyledProject>
      ))}
    </StyledGrid>
  </StyledPortfolioSection>
);

export default Portfolio;